import React from "react";
import '../Dashboard.css';
import classes from "./Analytics.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

function Analytics() {
  return (
    <div className="container_wrapper">
      <Header />
      <div className={`${styles.main} main`}>
        <Sidebar active="analytics" />
        <div className={styles.main_content}>
          <div className={styles.content_body}>
            <h3>Coming Soon..!</h3>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Analytics;